import React from 'react'
import { Info } from 'lucide-react'

interface AccountBalanceProps {
  darkMode: boolean;
}

const AccountBalance: React.FC<AccountBalanceProps> = ({ darkMode }) => {
  return (
    <div className={`rounded-lg shadow p-4 md:p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className={`text-lg md:text-xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>Solde</h2>
        <Info className={darkMode ? 'text-gray-400' : 'text-gray-500'} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Solde du compte</p>
          <p className={`text-xl md:text-2xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>+ 79 067,89 EUR</p>
        </div>
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Exécuté</p>
          <p className={`text-xl md:text-2xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>+ 79 085,79 EUR</p>
        </div>
        <div>
          <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>En cours</p>
          <p className={`text-xl md:text-2xl font-semibold ${darkMode ? 'text-white' : 'text-gray-800'}`}>- 17,90 EUR</p>
        </div>
      </div>
      <div className={`mt-6 h-48 rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
        {/* Placeholder for the graph */}
        <p className={`text-center pt-20 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>Graph placeholder</p>
      </div>
    </div>
  )
}

export default AccountBalance